export const ASSET = "Asset";
export const USER = "User";
export const LOADS = "Loads";
export const GROUP = "Group";
